"use client";
import dynamic from "next/dynamic";
import { useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
  DialogClose,
} from "@/components/ui/dialog";
const loadRequestPanel = () => import("./request-panel");
const RequestPanel = dynamic(loadRequestPanel, {
  loading: () => (
    <div
      className="flex min-h-[420px] items-center justify-center text-sm text-muted"
      role="status"
    >
      Loading request client…
    </div>
  ),
  ssr: false,
});
export function TryRequest(props: {
  requiresAuth: boolean;
  method: string;
  path: string;
  example: string;
}) {
  const [open, setOpen] = useState(false);
  const trigger = useRef<HTMLButtonElement>(null);
  return (
    <>
      <Button
        className="api-test-trigger"
        ref={trigger}
        onMouseEnter={() => void loadRequestPanel()}
        onFocus={() => void loadRequestPanel()}
        onClick={() => setOpen(true)}
        aria-haspopup="dialog"
      >
        Test it
        <svg
          className="!size-2.5"
          viewBox="0 0 10 10"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          aria-hidden
        >
          <path className="docs-arrow-line" d="M0 5h7" />
          <path className="docs-arrow-tip" d="m1 1 4 4-4 4" />
        </svg>
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          className="api-request-dialog max-h-[90svh] overflow-auto p-0 sm:max-w-3xl"
          overlayClassName="duration-300 ease-in-out motion-reduce:animate-none"
          showCloseButton={false}
          onCloseAutoFocus={() =>
            trigger.current?.focus({ preventScroll: true })
          }
        >
          <DialogTitle className="sr-only">Test {props.path}</DialogTitle>
          <DialogDescription className="sr-only">
            Send a request to the NexumAPI playground.
          </DialogDescription>
          <DialogClose
            aria-label="Close request client"
            className="absolute right-4 top-4 z-10 rounded-md p-1 text-muted hover:text-primary"
          >
            <X size={18} />
          </DialogClose>
          <RequestPanel {...props} />
        </DialogContent>
      </Dialog>
    </>
  );
}
